import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { STACK_SCREEN_OPTIONS } from './screenOptions';
import { CoachingScreen } from '../screens/CoachingScreen';
import { CoachingBookingScreen } from '../screens/CoachingBookingScreen';
import { CoachingReservationScreen } from '../screens/CoachingReservationScreen';
import type { CoachingFormuleId } from '../config/coaching';

export type CoachingStackParamList = {
  Coaching: undefined;
  CoachingBooking: { formule: CoachingFormuleId };
  CoachingReservation: { formule: CoachingFormuleId; bookingUid?: string };
};

const Stack = createNativeStackNavigator<CoachingStackParamList>();

export function CoachingNavigator() {
  return (
    <Stack.Navigator screenOptions={STACK_SCREEN_OPTIONS}>
      <Stack.Screen name="Coaching">
        {/* Coaching est monté au ROOT (au-dessus de Main) → le retour pope la pile parente. */}
        {({ navigation }) => (
          <CoachingScreen
            onBack={() => navigation.getParent()?.goBack()}
            // Le créneau AVANT le paiement : on n'ouvre plus la réservation directement.
            onReserve={(formule) => navigation.navigate('CoachingBooking', { formule })}
          />
        )}
      </Stack.Screen>
      <Stack.Screen name="CoachingBooking">
        {({ navigation, route }) => (
          <CoachingBookingScreen
            formule={route.params.formule}
            onBack={() => navigation.goBack()}
            // `replace` : une fois le créneau pris, revenir en arrière ne doit pas ramener
            // sur le calendrier, ce qui provoquerait une seconde réservation.
            onBooked={(bookingUid) =>
              navigation.replace('CoachingReservation', { formule: route.params.formule, bookingUid })
            }
          />
        )}
      </Stack.Screen>
      <Stack.Screen name="CoachingReservation">
        {({ navigation, route }) => (
          <CoachingReservationScreen
            formule={route.params.formule}
            bookingUid={route.params.bookingUid}
            onBack={() => navigation.goBack()}
          />
        )}
      </Stack.Screen>
    </Stack.Navigator>
  );
}
